var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIngred(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 179.2 139.7",
    style: {
      enableBackground: "new 0 0 179.2 139.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.3,114.5L81.7,50.4c-1.1-1.9-2.6-3.5-4.3-4.7V21.9h1.2c0.9,0,1.8-0.4,2.4-1c0.6-0.6,1-1.5,1-2.4 c0-1.9-1.5-3.4-3.4-3.4h-6.1l4.3-15H45.2c0.4,0.4,2.9,9.8,4.3,15H43c-0.9,0-1.8,0.4-2.4,1c-0.6,0.6-1,1.5-1,2.4 c0,1.9,1.5,3.4,3.4,3.4h1.1v24.3c-1.5,1.2-2.8,2.7-3.8,4.5L2.8,115.4c-3,5.1-3,11.3,0,16.4c3,5.1,8.2,8.1,14.1,8.1H17l89.4-0.6 c6,0,11.2-3.2,14.1-8.3C123.5,125.8,123.4,119.6,120.3,114.5z M17.8,99.5l26.8-46.4c1.1-2,2.9-3.5,4.8-4.5h23.2 c1.9,1,3.6,2.4,4.7,4.3L105,98.9L17.8,99.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -43.9249 59.276)",
    className: "st0",
    cx: 49.6,
    cy: 82.7,
    rx: 9.8,
    ry: 9.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 66.3,
    cy: 64.9,
    r: 5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.7,48l-40-37.6c-0.7-0.7-1.6-1-2.5-1c-1,0-1.9,0.4-2.7,1.2c-1.4,1.5-1.3,3.8,0.2,5.2l1.3,1.2L93.5,59.3 l28,47.3l52.1-53.4l0.1,0.1c1.5,1.4,3.8,1.3,5.2-0.2C180.2,51.7,180.1,49.3,178.7,48z M157.5,62.5h-56.4L99.7,60l37.1-37.9 L167.7,52L157.5,62.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.7,52.8c0,3.3-2.7,6-6,6s-6-2.7-6-6c0-3.3,2.7-6,6-6S134.7,49.4,134.7,52.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.9,51.8c0,1.7-1.3,3-3,3c-1.7,0-3-1.4-3-3c0-1.7,1.3-3,3-3C151.6,48.7,152.9,50.1,152.9,51.8z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.9,40.2c0,2.3-1.8,4.1-4.1,4.1s-4.1-1.8-4.1-4.1s1.8-4.1,4.1-4.1S145.9,37.9,145.9,40.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.8,84.9c0,4-3.3,7.3-7.3,7.3c-4,0-7.3-3.3-7.3-7.3c0-4,3.3-7.3,7.3-7.3C79.6,77.6,82.8,80.8,82.8,84.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngred);
export default __webpack_public_path__ + "static/media/Ingred.334d3d01ea2f014d9b6df22143542edd.svg";
export { ForwardRef as ReactComponent };